<template>
	<div class="sidenavbar">
		<div>

			<!--<img style="width: 50px;height: auto;margin-bottom: 2rem;" src="data:image/png;base64,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" alt="barnatasa">
		-->
		</div>
		<div style="margin: 0 auto">
			<li class="navli" @click.prevent="goTo('appraisalfiles-index')" v-if="filesOpen">
				<icon name="folder-open" scale="1"></icon>
				<span>&ensp;{{ $t('Files') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('appraisalfiles-index')" v-else>
				<icon name="folder-o" scale="1"></icon>
				<span>&ensp;{{ $t('Files') }}</span>
			</li>
			<ul class="navul" v-if="fileOpen">
				<li class="navli" @click.prevent="goToFile()">
					<icon name="folder-open" scale="1"></icon>
					<span>&ensp;{{ fileNumber }}</span>
				</li>
				<ul class="navul" v-if="reportOpen">
					<li class="navli" @click.prevent="goToReport(reportId)">
						<icon name="file-text" scale="1"></icon>
						<span>&ensp;{{ $t('Report') }} nº {{ reportNumber }} (v. {{ versionNumber }})</span>
					</li>
					<ul class="navul" v-if="realEstates">
						<li class="navli" v-for="realEstate in realEstates"
							@click.prevent="goToRealEstate(realEstate.id)">
							<div v-if="realEstate.id === realEstateId">
								<icon name="building" scale="1"></icon>
							</div>
							<div v-else>
								<icon name="building-o" scale="1"></icon>
							</div>
							<span>
								<span v-if="realEstate.street_name">{{ realEstate.street_name }}</span><span
									v-if="realEstate.street_number">, {{ realEstate.street_number }}</span><span
									v-if="realEstate.floor">, {{ realEstate.floor }}</span><span v-if="realEstate.door">-{{ realEstate.door
								}}</span></span>
						</li>
					</ul>
				</ul>
			</ul>

			<li class="navli" @click.prevent="goTo('realestates-index')">
				<icon name="building-o" scale="1"></icon>
				<span>&ensp;{{ $t('Real_estates') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('ads-index')">
				<icon name="bookmark-o" scale="1"></icon>
				<span>&ensp;{{ $t('Ads') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('contacts-index')">
				<icon name="address-card-o" scale="1"></icon>
				<span>&ensp;{{ $t('Contacts') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('appraisalquotes-index')">
				<icon name="file-powerpoint-o" scale="1"></icon>
				<span>&ensp;{{ $t('Quotes') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('appraisalinvoices-index')">
				<icon name="eur" scale="1"></icon>
				<span>&ensp;{{ $t('Invoices') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('appraisers-index')">
				<icon name="user-circle-o" scale="1"></icon>
				<span>&ensp;{{ $t('Appraisers') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('supervisors-index')">
				<icon name="user-circle" scale="1"></icon>
				<span>&ensp;{{ $t('Supervisors') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('entities-index')">
				<icon name="university" scale="1"></icon>
				<span>&ensp;{{ $t('Entities') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('becproperties-index')">
				<icon name="tag" scale="1"></icon>
				<span>&ensp;{{ $t('Construction_prices') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('bdefiles-index')">
				<icon name="archive" scale="1"></icon>
				<span>&ensp;{{ $t('BdE_files') }}</span>
			</li>
		</div>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'side-nav-bar',

        data: () => ({
            showShareNote: false
        }),

        computed: {
            ...mapGetters(['currentLocale'
            ])
        },
        props: {
            fileOpen: {type: Boolean, default: false},
            filesOpen: {type: Boolean, default: false},
            fileId: {type: String, default: ''},
            fileNumber: {type: Number, default: 0},
            filePath: {type: String, default: 'appraisalfiles/'},
            realEstateId: {type: String, default: ''},
            realEstates: {type: Object, default: function () { return {} }},
            reportId: {type: String, default: ''},
            reportNumber: {type: Number, default: 0},
            reportOpen: {type: Boolean, default: false},
            versionNumber: {type: Number, default: 0},
            full_number: {type: String, default: ''}
        },

        methods: {
            ...mapActions(
                [
                    'SET_APPRAISALREPORT',
                    'SET_REALESTATE',
                ]),
            goTo (location,) {
                this.$router.push({name: location})
            },
            goToFile () {
                this.$router.push({name: 'appraisalfile-editor', query: {id: this.fileId}})
            },
            goToReport (id) {
                this.SET_APPRAISALREPORT({path: 'appraisalreports' + '/' + id + '/'}).then((res) => {
                    this.$router.push({name: 'appraisalreport-editor', query: {id: id}})

                })
            },
            goToRealEstate (id) {
                this.SET_REALESTATE({path: 'realestates' + '/' + id + '/'}).then((res) => {
                    this.$router.push({name: 'realestate-editor', query: {id: id}})

                })
            }
        }

    }
</script>

<style>
	@media screen and (max-width: 1280px) {
		.sidenavbar {
			display: none !important;
		}
	}
	.sidenavbar {
		position: relative;
		width: 300px;
		height: 100vh;
		display: inline-block;
		vertical-align: top;
		padding-top: 6rem;
		padding-left: 1rem;
		padding-right: 1rem;
		/*background: #fafafc;*/
		/*background: whitesmoke;*/
		color: black;
		font-size: .8rem;
		z-index: 10;
	}

	.navul {
		list-style: none;
		margin-top: 0;
		padding-left: 1rem;

	}

	.navli {
		list-style: none;
		padding-top: 0.5rem;
	}

	.navli:hover {
		/*color: #0c3b61;*/
		color: #2196f3;
		cursor: pointer;

	}
</style>


// WEBPACK FOOTER //
// Index.vue?2a6e592d